import(/* webpackMode: "eager" */ "/codebuild/output/src1395234516/src/helloero-new/packages/account/src/app/error.tsx");
